import { CSSProperties, RefObject, useState } from 'react';

interface UseAutofillStyle {
  autofillStyles: CSSProperties;
  updateStyle: () => void;
}

export function useAutofillStyle<T>(
  inputRef: RefObject<
    T extends 'input' ? HTMLInputElement : HTMLTextAreaElement
  >
): UseAutofillStyle {
  const [styles, setStyles] = useState<CSSProperties>({});

  const updateStyle = () => {
    const input = inputRef.current;
    if (input) {
      const color = window.getComputedStyle(input).backgroundColor;

      setStyles({
        boxShadow: `-100px 0 ${color}, 100px 0 ${color}`,
      });
    }
  };

  return {
    autofillStyles: styles,
    updateStyle,
  };
}
